import { render, staticRenderFns } from "./dialogShowDetail.vue?vue&type=template&id=817a2240"
import script from "./dialogShowDetail.vue?vue&type=script&lang=js"
export * from "./dialogShowDetail.vue?vue&type=script&lang=js"
import style0 from "./dialogShowDetail.vue?vue&type=style&index=0&id=817a2240&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports